import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

activeFaq: number | null = null;
showAllFaqs = false;

toggleFaq(id: number): void {
  this.activeFaq = this.activeFaq === id ? null : id;
}

toggleAllFaqs(): void {
  this.showAllFaqs = !this.showAllFaqs;

  if (!this.showAllFaqs) {
    this.activeFaq = null;

    setTimeout(() => {
      const faqSection = document.querySelector('.seo-faq-section');

      if (faqSection) {
        faqSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  }
}
}
